/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Document_Title_HelpInputs */

const en_ccsl_export_document_title_help = /** @type {(inputs: Ccsl_Export_Document_Title_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the title for your CCSL document`)
};

const fr_ccsl_export_document_title_help = /** @type {(inputs: Ccsl_Export_Document_Title_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez le titre de votre document CCSL`)
};

const de_ccsl_export_document_title_help = /** @type {(inputs: Ccsl_Export_Document_Title_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie den Titel für Ihr CCSL-Dokument ein.`)
};

const it_ccsl_export_document_title_help = /** @type {(inputs: Ccsl_Export_Document_Title_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il titolo per il tuo documento CCSL`)
};

const ru_ccsl_export_document_title_help = /** @type {(inputs: Ccsl_Export_Document_Title_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите название вашего документа CCSL.`)
};

const es_ccsl_export_document_title_help = /** @type {(inputs: Ccsl_Export_Document_Title_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca el título de su documento CCSL`)
};

const zh_cn2_ccsl_export_document_title_help = /** @type {(inputs: Ccsl_Export_Document_Title_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入您的 CCSL 文档标题`)
};

const ja_ccsl_export_document_title_help = /** @type {(inputs: Ccsl_Export_Document_Title_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL文書のタイトルを入力してください`)
};

const hi_ccsl_export_document_title_help = /** @type {(inputs: Ccsl_Export_Document_Title_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने CCSL दस्तावेज़ के लिए शीर्षक दर्ज करें`)
};

const pt_pt2_ccsl_export_document_title_help = /** @type {(inputs: Ccsl_Export_Document_Title_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira o título do seu documento CCSL.`)
};

/**
* | output |
* | --- |
* | "Enter the title for your CCSL document" |
*
* @param {Ccsl_Export_Document_Title_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_document_title_help = /** @type {((inputs?: Ccsl_Export_Document_Title_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Document_Title_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_document_title_help(inputs)
	if (locale === "de") return de_ccsl_export_document_title_help(inputs)
	if (locale === "it") return it_ccsl_export_document_title_help(inputs)
	if (locale === "ru") return ru_ccsl_export_document_title_help(inputs)
	if (locale === "es") return es_ccsl_export_document_title_help(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_document_title_help(inputs)
	if (locale === "ja") return ja_ccsl_export_document_title_help(inputs)
	if (locale === "hi") return hi_ccsl_export_document_title_help(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_document_title_help(inputs)
	return en_ccsl_export_document_title_help(inputs)
});